var map = {
	"./capcut.png": 8987,
	"./facebook.png": 3759,
	"./movavi.png": 2357,
	"./photopea.png": 825,
	"./tiktok.png": 4586,
	"./vegas_pro.png": 2805,
	"./youtube.png": 9782
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2072;